import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import Dashboard from './Dashboard'
import ManageTeams from './Teams'
import TeamManage from './Teams/TeamManage'
import ManageProjects from './Projects'
import ManageProject from './Projects/ManageProject'
import ManageJobs from './Jobs'
import ManageJob from './Jobs/ManageJob'
import ManageOrganizations from './Organizations'
import ManageUsers from './Users'
import AuthUserDetail from './Users/AuthUserDetail'
import Support from './Support'
import AgendaStats from './AgendaStats'
import ExpertRecommendationPerformance from './ExpertRecommendationPerformance'
import AICost from './AICost'
import Sourcing from './Sourcing'
import ExternalExpertDetail from './Sourcing/ExternalExpertDetail'

const AdminRoutes = () => (
    <Switch>
        <Route
            exact
            path="/admin"
            render={() => <Redirect to="/admin/teams" />}
        />
        <Route exact path="/admin/dashboard" component={Dashboard} />
        <Route exact path="/admin/teams" component={ManageTeams} />
        <Route exact path="/admin/teams/:id/:page" component={TeamManage} />
        <Route exact path="/admin/projects" component={ManageProjects} />
        <Route exact path="/admin/projects/:id" component={ManageProject} />
        <Route exact path="/admin/jobs" component={ManageJobs} />
        <Route exact path="/admin/jobs/:id" component={ManageJob} />
        <Route
            exact
            path="/admin/organizations"
            component={ManageOrganizations}
        />
        <Route
            exact
            path="/admin/organizations/merge"
            render={() => <Redirect to="/admin/organizations" />}
        />
        <Route exact path="/admin/users" component={ManageUsers} />
        <Route exact path="/admin/users/:userId" component={AuthUserDetail} />
        <Route exact path="/admin/support" component={Support} />
        <Route exact path="/admin/agenda" component={AgendaStats} />
        <Route
            exact
            path="/admin/expert-recommendations"
            component={ExpertRecommendationPerformance}
        />
        <Route exact path="/admin/ai-cost" component={AICost} />
        <Route exact path="/admin/sourcing" component={Sourcing} />
        <Route
            exact
            path="/admin/sourcing/:registrationNumber"
            component={ExternalExpertDetail}
        />
        <Route render={() => <Redirect to="/not-found-page" />} />
    </Switch>
)

export default AdminRoutes
